import { useEffect } from "react";

const MultipleDocumentsSend = ({
  containerRef,
  label,
  dropX = 40,
  dropY = 100,
  setSignatureFields,
  setSelectedField,
  setModePayload,
}) => {
  useEffect(() => {
    if (!containerRef?.current) return;

    const lastPageContainer = containerRef.current.lastElementChild;

    const lastTextLayer = lastPageContainer?.querySelector("div");

    if (!lastTextLayer) return;

    /* ===============================
       WRAPPER
    ================================ */
    const wrapper = document.createElement("div");
    wrapper.style.position = "absolute";
    wrapper.style.left = `${dropX}px`;
    wrapper.style.top = `${dropY}px`;
    wrapper.style.display = "flex";
    wrapper.style.alignItems = "center";
    wrapper.style.gap = "6px";
    wrapper.style.cursor = "move";

    /* ===============================
       FIELD
    ================================ */
    const field = document.createElement("div");
    field.innerText = label;
    field.contentEditable = true;
    field.style.padding = "4px 8px";
    field.style.border = "1px solid #666";
    field.style.backgroundColor = "#f9f9f9";
    field.style.borderRadius = "4px";
    field.style.fontSize = "14px";
    field.style.fontFamily = "Arial";
    field.style.color = "#000";
    /* ===============================
       ICONS
    ================================ */
    const deleteIcon = document.createElement("span");
    deleteIcon.innerHTML = "❌";
    deleteIcon.style.cursor = "pointer";
    deleteIcon.title = "Delete Field";

    const editIcon = document.createElement("span");
    editIcon.innerHTML = "✏️";
    editIcon.style.cursor = "pointer";
    editIcon.title = "Edit Field";

    const saveIcon = document.createElement("span");
    saveIcon.innerHTML = "✅";
    saveIcon.style.cursor = "pointer";
    saveIcon.title = "Save Position";

    /* ===============================
       DRAG LOGIC
    ================================ */
    let isDragging = false;
    let offsetX = 0;
    let offsetY = 0;

    const onMouseMove = (e) => {
      if (!isDragging) return;

      const parentRect = lastTextLayer.getBoundingClientRect();

      const newX = e.clientX - parentRect.left - offsetX;

      const newY = e.clientY - parentRect.top - offsetY;

      wrapper.style.left = `${newX}px`;
      wrapper.style.top = `${newY}px`;
    };

    const onMouseUp = () => {
      isDragging = false;

      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);

      const newX = parseFloat(wrapper.style.left);
      const newY = parseFloat(wrapper.style.top);

      setSignatureFields((prev) =>
        prev.map((f) =>
          f.id === fieldData.id ? { ...f, x: newX, y: newY } : f,
        ),
      );
    };

    field.addEventListener("mousedown", (e) => {
      isDragging = true;
      const wrapperRect = wrapper.getBoundingClientRect();
      offsetX = e.clientX - wrapperRect.left;
      offsetY = e.clientY - wrapperRect.top;
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
      e.stopPropagation();
    });

    /* ===============================
       ICON EVENTS
    ================================ */
    deleteIcon.addEventListener("click", () => {
      wrapper.remove();
      setSignatureFields((prev) => prev.filter((f) => f.id !== fieldData.id));
    });

    editIcon.addEventListener("click", () => setSelectedField(field));

    saveIcon.addEventListener("click", () => {
      const newX = parseFloat(wrapper.style.left);
      const newY = parseFloat(wrapper.style.top);

      setSignatureFields((prev) =>
        prev.map((f) =>
          f.id === fieldData.id ? { ...f, x: newX, y: newY, saved: true } : f,
        ),
      );

      field.contentEditable = false;
    });

    /* ===============================
       APPEND
    ================================ */
    wrapper.appendChild(field);
    wrapper.appendChild(deleteIcon);
    wrapper.appendChild(editIcon);
    wrapper.appendChild(saveIcon);

    lastTextLayer.appendChild(wrapper);

    /* ===============================
       STORE FIELD DATA
    ================================ */
    const fieldData = {
      id: Date.now() + Math.random(),
      label,
      signatoryName: "", // No signatory for multi_doc
      x: dropX,
      y: dropY,
      pageIndex: containerRef.current.children.length - 1,
      saved: false,
    };

    setSignatureFields((prev) => [...prev, fieldData]);
    if (setModePayload) setModePayload(null);
  }, [dropX, dropY, setModePayload]);

  return null;
};

export default MultipleDocumentsSend;
